import { put } from '../index';

export function editPost({ id, body }) {
  return put(id, body, false);
}
